import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";

const CONTACT_URL = "https://www.c-metric.com/contact/";
const CONTACT_EMAIL = "info@c-metric.com";

function Privacy() {
  return (
    <div>
      <div className="container my-5 privacy_policy">
        <div className="mb-4">
          <h1 className="text-dark">Privacy Policy</h1>
          <p className="text-muted">
            <span className="text-nowrap"><strong>Effective Date:</strong> 26-02-2025</span> ·{" "}
            <span className="text-nowrap"><strong>Last updated:</strong> 02-11-2026</span>
          </p>
          <p>
            Welcome to Aivio. Your privacy is important to us, and we are
            committed to protecting the personal information you share with us.
            This Privacy Policy outlines how we collect, use, and protect your
            information when you use our services.
          </p>
        </div>
        <div className="card mb-5">
          <div className="card-body p-4">

            <div className="mb-4">
              <h4 className="text-dark">1. Information We Collect</h4>
              <p>We may collect the following types of information:</p>
              <ul>
                <li>
                  <strong>Personal Information:</strong> Name, email address, and
                  other identifying details when you register or contact us.
                </li>
                <li>
                  <strong>Usage Data:</strong> The questions you ask the Aivio AI
                  agent and the answers it provides.
                </li>
                <li>
                  <strong>Cost Estimate Details:</strong> Your email address and the
                  usage figures you enter on the Know your cost form.
                </li>
                <li>
                  <strong>Browser Storage:</strong> We use your browser’s session
                  storage to keep you logged in during a visit and to remember
                  whether you have seen the chat greeting. This information is
                  cleared when you close the browser tab. We do not use advertising
                  or analytics cookies.
                </li>
              </ul>
            </div>

            <div className="mb-4">
              <h4 className="text-dark">2. How We Use Your Information</h4>
              <ul>
                <li>Provide and improve our services.</li>
                <li>Authenticate users and manage access to restricted data.</li>
                <li>Prepare the cost estimates you request.</li>
                <li>
                  Communicate with users regarding updates, support, or security
                  alerts.
                </li>
                <li>Analyze user interactions to improve the Aivio agent’s answers.</li>
              </ul>
            </div>

            <div className="mb-4">
              <h4 className="text-dark">3. Data Sharing & Third-Party Services</h4>
              <p>
                We do not sell or rent your personal information. However, we may
                share information with:
              </p>
              <ul>
                <li>
                  <strong>AI Service Provider:</strong> Questions you ask the Aivio
                  agent are processed by IBM watsonx Orchestrate to generate answers.
                </li>
                <li>
                  <strong>Service Providers:</strong> Third-party services that
                  assist us in operations (e.g., cloud hosting and storage).
                </li>
                <li>
                  <strong>Legal Requirements:</strong> If required by law, we may
                  disclose data in response to legal processes.
                </li>
              </ul>
            </div>

            <div className="mb-4">
              <h4 className="text-dark">4. Data Security</h4>
              <p>
                We implement appropriate security measures to protect your
                information from unauthorized access, alteration, or disclosure.
              </p>
            </div>

            <div className="mb-4">
              <h4 className="text-dark">5. Your Rights & Choices</h4>
              <ul>
                <li>
                  You can request access to, correction, or deletion of your
                  personal information.
                </li>
                <li>You may opt out of marketing communications at any time.</li>
                <li>
                  You can clear stored session information at any time through your
                  browser settings.
                </li>
                <li>
                  For data deletion requests, please contact us through this link:{" "}
                  <a
                    href={CONTACT_URL}
                    className="text-primary"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Contact Us
                  </a>
                  .
                </li>
              </ul>
            </div>

            <div className="mb-4">
              <h4 className="text-dark">6. Changes to This Policy</h4>
              <p>
                We may update this Privacy Policy periodically. Any changes will be
                communicated through our platform.
              </p>
            </div>

            <div className="mb-0">
              <h4 className="text-dark">7. Contact Us</h4>
              <p>
                If you have any questions about this Privacy Policy, please contact
                us at <a href={`mailto:${CONTACT_EMAIL}`} className="text-primary">{CONTACT_EMAIL}</a> or
                through our{" "}
                <a href={CONTACT_URL} className="text-primary" target="_blank" rel="noopener noreferrer">
                  contact page
                </a>
                .
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Privacy;
